var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.7907C14.9706 18.7907 19 14.8081 19 9.89535C19 4.98258 14.9706 1 10 1C5.02944 1 1 4.98258 1 9.89535C1 14.8081 5.02944 18.7907 10 18.7907Z",
    stroke: "#34303D",
    strokeWidth: 0.77
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1949 9.89517C17.1949 13.8184 13.9763 17.0037 9.99981 17.0037C6.02329 17.0037 2.80469 13.8184 2.80469 9.89517C2.80469 5.97197 6.02329 2.78662 9.99981 2.78662C13.9763 2.78662 17.1949 5.97197 17.1949 9.89517Z",
    fill: "#00D1D2",
    stroke: "#FFFDFB",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99981 6.95268C10.3837 6.95268 10.6949 6.64509 10.6949 6.26565C10.6949 5.88621 10.3837 5.57861 9.99981 5.57861C9.6159 5.57861 9.30469 5.88621 9.30469 6.26565C9.30469 6.64509 9.6159 6.95268 9.99981 6.95268Z",
    fill: "#34303D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5964 8.68266C10.5964 8.35755 10.3298 8.09399 10.0009 8.09399C9.67193 8.09399 9.40527 8.35755 9.40527 8.68266V13.7844C9.40527 14.1095 9.67193 14.3731 10.0009 14.3731C10.3298 14.3731 10.5964 14.1095 10.5964 13.7844V8.68266Z",
    fill: "#34303D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.eec36a4ea9dbcb1b31d11bfa70cbe871.svg";
export { ForwardRef as ReactComponent };